"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var FirebaseProvider_1 = require("../../providers/FirebaseProvider");
var isProduction = process.env.NODE_ENV === 'production';
var useAnalytics = function () {
    var analytics = FirebaseProvider_1.useFirebase().analytics;
    var logEvent = react_1.useCallback(function (event, data) {
        if (isProduction) {
            analytics.logEvent(event, data);
        }
        else {
            // eslint-disable-next-line no-console
            console.log('Analytics event:', event, data);
        }
    }, [analytics]);
    return {
        logEvent: logEvent,
    };
};
exports.default = useAnalytics;
//# sourceMappingURL=useAnalytics.js.map